import { Component } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { ICellRendererParams } from "ag-grid-community";
import { AnnualRecord } from "../../../../../../../models/annualRecord";
import { AnnualStatementStatus } from "../../../../../../../models/enums/annualStatementEnums";
import { TooltipComponent } from "../../../../tooltip/tooltip.component";

type ActionEvent = (data: unknown) => void;

type CellRendererParams = ICellRendererParams<AnnualRecord> & {
  view: ActionEvent,
  send: ActionEvent,
  edit: ActionEvent,
  downloadDocuments: ActionEvent,
  archive: ActionEvent,
  sendReminder: ActionEvent,
  regenerate: ActionEvent,
  markSent: ActionEvent,
  markSigned: ActionEvent
};

@Component({
  selector: 'app-ag-annual-actions',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    TooltipComponent
  ],
  templateUrl: './ag-annual-actions.component.html',
  styleUrl: './ag-annual-actions.component.scss'
})
export class AgAnnualActionsComponent {
  protected params!: CellRendererParams;
  protected status: AnnualStatementStatus | null | undefined;
  protected documentId: string | null | undefined;
  protected AnnualStatementStatus = AnnualStatementStatus;
  protected readonly tooltipMessage = 'Customise and Send ';
  protected readonly menuActions = [
    { name: 'Download Documents', iconClass: 'icon ic-download-file mr-1', action: () => this.downloadDocuments() },
    { name: 'Archive', iconClass: 'icon ic-archive mr-1', action: () => this.archive() },
    { name: 'Send ad-hoc Reminder', iconClass: 'icon ic-bell mr-1', action: () => this.sendReminder() },
    { name: 'Re-generate', iconClass: 'icon ic-refresh mr-1', action: () => this.regenerate() },
    { name: 'Manually Mark as Sent', iconClass: 'icon ic-circle-check mr-1', action: () => this.markSent() },
    { name: 'Manually Mark as Signed', iconClass: 'icon ic-circle-check mr-1', action: () => this.markSigned() },
  ];

  agInit(params: CellRendererParams): void {
    this.params = params;
    this.status = params.data?.status;
    this.documentId = params.data?.documentId;
  }

  refresh(params: CellRendererParams): boolean {
    this.params = params;
    this.status = params.data?.status;
    this.documentId = params.data?.documentId;
    return true;
  }

  view(): void {
    this.params.view(this.params.data?.companyId);
  }

  send(): void {
    this.params.send(this.params.data?.documentId);
  }

  edit(): void {
    this.params.edit(this.params.data?.documentId);
  }

  downloadDocuments(): void {
  }

  archive(): void {
  }

  sendReminder(): void {
    this.params.sendReminder(this.params.data?.companyId);
  }

  regenerate(): void {
  }

  markSent(): void {
  }

  markSigned(): void {
  }
}
